export enum QuizCode {
  WEIGHT_LOSS_SUPPORT = 'weightLossSupport',
  SKIN_ONBOARDING = 'skinOnboardingQuiz',
  CHECK_IN = 'skinCheckInQuiz',
  SKIN_SUPPORT = 'skinSupportQuiz',
}
